module.exports = __webpack_public_path__ + "img/manutd3.c6b3b6c7.jpeg";